import { render } from "./responses.vue?vue&type=template&id=268d26f4"
import script from "./responses.vue?vue&type=script&lang=js"
export * from "./responses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__